module.exports = new __parcel__URL__("bossfight_notification_later_button.8f436706.png").toString();